const topicItems = [
  { label: '#热播剧推荐', hot: '128万讨论' },
  { label: '#高清免费看片', hot: '96万讨论' },
  { label: '#不缓冲追剧', hot: '83万讨论' },
  { label: '#古装权谋', hot: '67万讨论' },
  { label: '#都市情感剧', hot: '58万讨论' },
  { label: '#悬疑烧脑', hot: '52万讨论' },
  { label: '#电影解说', hot: '45万讨论' },
  { label: '#综艺名场面', hot: '41万讨论' },
  { label: '#国漫崛起', hot: '37万讨论' },
  { label: '#科幻动作', hot: '32万讨论' },
  { label: '#免费追剧平台', hot: '28万讨论' },
];

const hotColors = [
  'bg-primary-100 text-primary-700 border-primary-200',
  'bg-accent-100 text-accent-700 border-accent-200',
  'bg-secondary-100 text-secondary-700 border-secondary-200',
  'bg-accent-100 text-accent-700 border-accent-200',
  'bg-primary-100 text-primary-700 border-primary-200',
  'bg-secondary-100 text-secondary-700 border-secondary-200',
  'bg-primary-100 text-primary-700 border-primary-200',
  'bg-accent-100 text-accent-700 border-accent-200',
  'bg-secondary-100 text-secondary-700 border-secondary-200',
  'bg-primary-100 text-primary-700 border-primary-200',
  'bg-accent-100 text-accent-700 border-accent-200',
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">全网影视爱好者正在热议的话题</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer hover:-translate-y-0.5 ${hotColors[i]}`}
              onClick={(e) => e.preventDefault()}
            >
              <span>{topic.label}</span>
              <span className="text-xs opacity-70">{topic.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}